import application from 'application/application';

application

	.directive('ngDocument', () => {

		const

			types = {
				CPF(value) {

					var value = value.replace(/[^\d]/g, '');

					if (value.length !== 11 || /^(\d)\1+$/.test(value))

						return false;

					var r;
					var s = 0;

					for (var i = 1; i <=9; i++)

						s = s + parseInt(value[i-1]) * (11 - i);

					r = (s * 10) % 11;

					if ((r == 10) || (r == 11))

						r = 0;

					if (r != parseInt(value[9]))

						return false;

					s = 0;

					for (var i = 1; i <= 10; i++)

						s = s + parseInt(value[i-1]) * (12 - i);

					r = (s * 10) % 11;

					if ((r == 10) || (r == 11))

						r = 0;

					if (r != parseInt(value[10]))

						return false;

					return true;

				},
				CNPJ(value) {

					var b = [ 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2 ];

					value = value.replace(/[^\d]/g, '');

					if (value.length !== 14)

						return false;

					if (/0{14}/.test(value))

						return false;

					for (var i = 0, n = 0; i < 12; n += value[i] * b[++i]);

					if (value[12] != (((n %= 11) < 2) ? 0 : 11 - n))

						return false;

					for (var i = 0, n = 0; i <= 12; n += value[i] * b[i++]);

					if (value[13] != (((n %= 11) < 2) ? 0 : 11 - n))

						return false;

					return true;

				}
			};

		return {
			require: 'ngModel',
			link(scope, element, attrs, controller) {

				controller.$validators.document = (modelValue, viewValue) => {

					if (controller.$isEmpty(modelValue) || modelValue === false)

						return true;

					return types[attrs.ngDocument](viewValue);

				};

			}
		};

	});
